import React from 'react';
import KnowledgeArticle from './KnowledgeArticle';
import { ListGroup, ListGroupItem } from 'react-bootstrap';

class KnowledgeArticles extends React.Component {
    render() {
        return this.props.data &&
            <ListGroup className="knowledge-article-list">
            {
                this.props.data.map((item, i, arr) =>
                    <ListGroupItem key={item.articleID}>
                        <KnowledgeArticle data={item} openByDefault={arr.length === 1} />
                    </ListGroupItem>)
            }
            </ListGroup>;
    }
}
export default KnowledgeArticles;
